/**
 * Input component
 *
 * Optional props:
 * size : string - size of loader (with unit)
 *
 * Examples of component:
 * <Loader />
 * <Loader size="small" />
 *
 */

import React from 'react';
import styled from 'styled-components';

const getSize = size => {
	const small = '20px';
	const medium = '40px';
	const large = '50px';

	if (!size) return medium;

	switch (size) {
		case 'small':
			return small;
		case 'medium':
			return medium;
		case 'large':
			return large;
		default:
			return size;
	}
};

const Container = styled.div`
	width: ${props => getSize(props.size)};
	height: ${props => getSize(props.size)};
	margin: ${props => props.margin || '40px'} auto;
`;

const Gif = styled.img`
	width: 100%;
	display: block;
`;

const Loader = props => (
	<Container {...props}>
		<Gif src="/images/loader/loader.gif" alt="Loading..." />
	</Container>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Common/Loader/Loader.js